import React, { Component } from 'react';

class ProjectCard extends Component {
    render() {
        return (
            <div class="widecard">
            <div class="compdet">
            <h2 class="project_title">{this.props.title}</h2>
            <img class={this.props.img_style_1} src={this.props.img_project_1} alt=''></img><img class={this.props.img_style_2} src={this.props.img_project_2} alt=''></img>
            <h3 class="secondtext">{this.props.description}</h3>
            <br></br>
            <a class="repo_link" target="_blank" rel="noreferrer" href={this.props.link}>Github Repo</a>
            </div>
            </div>
            )
        }
    }
    
export default ProjectCard
    